import { OptionItem } from 'tno-core';

export const summaryOptions = [new OptionItem('Text', 0), new OptionItem('Rendered as HTML', 1)];
